const fetchImg = (name) => {
    return `https://azweuglostpdnobkbkp.blob.core.windows.net/azpdnspacebookingstorage/${name}?st=2023-06-08T00:51:25Z&si=racwdl&spr=https&sv=2022-11-02&sr=c&sig=HeVsTmdN0xUKrtbmzXLBI8Kjz%2FbssPaJozlKfp5YYl4%3D`;
};

export default fetchImg;
